// Экранная отладка рекламы: работает ТОЛЬКО в dev-сборке (npm start).
// В прод-сборке (react-scripts build) полностью выключена — оверлей,
// перехват console и сетевые логи пользователям не показываются.
// Для локальной отладки всегда можно временно поставить true.
const AD_DEBUG_ENABLED = process.env.NODE_ENV !== 'production';
const MAX_LINES = 14;

const lines = [];
let overlay = null;
let logArea = null;
let counterEl = null;

function copyToClipboard() {
  const text = ['[AD DEBUG]', ...lines].join('\n');

  const done = () => adLog('Лог скопирован в буфер обмена');
  const fail = () => adLog('Копирование не сработало — тапните по тексту лога и скопируйте вручную');

  if (navigator.clipboard?.writeText) {
    navigator.clipboard
      .writeText(text)
      .then(done)
      .catch(() => legacyCopy(text) ? done() : fail());
  } else {
    legacyCopy(text) ? done() : fail();
  }
}

// Фоллбек для WebView без Clipboard API: невидимая textarea + execCommand
function legacyCopy(text) {
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;left:-9999px;top:0';
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch (e) {
    return false;
  }
}

function render() {
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.setAttribute('data-our', 'ad-debug');
    overlay.style.cssText = [
      'position:fixed',
      'top:8px',
      'left:8px',
      'right:8px',
      'max-height:40vh',
      'display:flex',
      'flex-direction:column',
      'background:rgba(0,0,0,0.88)',
      'color:#A1F69E',
      'font:11px/1.45 monospace',
      'border-radius:8px',
      'border:1px solid #A1F69E55',
      'z-index:2147483000',
      'pointer-events:none' // контейнер не мешает приложению, кнопки — мешают
    ].join(';');

    // Шапка с кнопками (они кликабельны)
    const header = document.createElement('div');
    header.style.cssText =
      'display:flex;gap:6px;align-items:center;padding:4px 6px;border-bottom:1px solid #A1F69E33;pointer-events:auto;flex-shrink:0';

    counterEl = document.createElement('span');
    counterEl.style.cssText = 'opacity:0.7;margin-right:auto';

    const makeBtn = (label, onClick) => {
      const b = document.createElement('button');
      b.textContent = label;
      b.style.cssText =
        'background:#A1F69E;color:#000;border:none;border-radius:5px;padding:2px 8px;font:11px monospace;cursor:pointer';
      b.addEventListener('click', onClick);
      return b;
    };

    header.appendChild(counterEl);
    header.appendChild(makeBtn('Копировать', copyToClipboard));
    header.appendChild(
      makeBtn('Скрыть', () => {
        overlay.style.display = 'none';
        pill.style.display = 'block';
      })
    );

    // Область лога: клик выделяет всё (user-select: all)
    logArea = document.createElement('div');
    logArea.style.cssText =
      'overflow-y:auto;padding:6px 10px;white-space:pre-wrap;word-break:break-all;user-select:all;pointer-events:auto';

    overlay.appendChild(header);
    overlay.appendChild(logArea);
    document.body.appendChild(overlay);

    // Пилюля для возврата лога после скрытия
    const pill = document.createElement('button');
    pill.textContent = 'AD DEBUG';
    pill.setAttribute('data-our', 'ad-debug-pill');
    pill.style.cssText =
      'position:fixed;left:8px;bottom:8px;display:none;background:rgba(0,0,0,0.85);color:#A1F69E;border:1px solid #A1F69E55;border-radius:999px;padding:4px 10px;font:11px monospace;z-index:2147483000;cursor:pointer';
    pill.addEventListener('click', () => {
      overlay.style.display = 'flex';
      pill.style.display = 'none';
    });
    document.body.appendChild(pill);
    overlay._pill = pill;
  }

  logArea.textContent = [...lines].slice(-MAX_LINES).join('\n');
  logArea.scrollTop = logArea.scrollHeight;
  counterEl.textContent = `${lines.length} строк`;
}

export function adLog(message) {
  if (!AD_DEBUG_ENABLED) return;
  const time = new Date().toLocaleTimeString();
  const line = `${time} ${message}`;
  console.log('[AD DEBUG]', message);
  lines.push(line);
  if (lines.length > 200) lines.shift();
  render();
}

// Ловим глобальные ошибки, отказы промисов и console.error/warn рекламных SDK
if (AD_DEBUG_ENABLED) {
  window.addEventListener('error', (e) => {
    // Ошибки загрузки ресурсов (script/img): у них нет message, но есть target.src
    if (!e.message && e.target?.src) {
      adLog(`РЕСУРС НЕ ЗАГРУЗИЛСЯ: ${String(e.target.src).slice(0, 100)} (блокировщик?)`);
      return;
    }
    adLog(`ERROR: ${e.message}`);
  });
  window.addEventListener('unhandledrejection', (e) => adLog(`PROMISE: ${e.reason?.message || e.reason}`));

  // TAds/RichAds пишут ошибки через console.error — дублируем на экран,
  // повторы схлопываем в счётчик
  const seen = new Map();
  const dedupe = (prefix) => {
    const original = console[prefix].bind(console);
    console[prefix] = (...args) => {
      const text = args.map((a) => (typeof a === 'string' ? a : a?.message || '')).join(' ').trim();
      if (text) {
        const count = (seen.get(text) || 0) + 1;
        seen.set(text, count);
        adLog(`${prefix.toUpperCase()}: ${text}${count > 1 ? ` (×${count})` : ''}`);
      }
      original(...args);
    };
  };
  dedupe('error');
  dedupe('warn');
}

export { AD_DEBUG_ENABLED };
